var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDistrokidLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 515.17 66.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#231f20;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "distrokid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,1.28H25c20.17,0,34.11,13.84,34.11,31.91v.18c0,18.06-13.94,32.09-34.11,32.09H0ZM25,52.72c11.55,0,19.35-7.79,19.35-19.16v-.18C44.39,22,36.59,14,25,14H14.13V52.72Z",
    transform: "translate(-0.01 -0.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.35,1.28H86.47V65.47H72.35Z",
    transform: "translate(-0.01 -0.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.12,56.11l8.34-10c5.78,4.77,11.83,7.79,19.16,7.79,5.78,0,9.26-2.29,9.26-6.05v-.18c0-3.58-2.2-5.41-12.93-8.16-12.93-3.3-21.27-6.88-21.27-19.62v-.18C100.68,8.07,110,.37,123.15.37A37.15,37.15,0,0,1,147,8.53l-7.34,10.64C134,15.22,128.38,12.84,123,12.84s-8.25,2.48-8.25,5.59v.18c0,4.22,2.75,5.59,13.84,8.44,13,3.39,20.36,8.07,20.36,19.25v.18c0,12.74-9.72,19.9-23.56,19.9A40.84,40.84,0,0,1,98.12,56.11Z",
    transform: "translate(-0.01 -0.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.77,14.3H155.24v-13h53.18v13H188.89V65.47H174.77Z",
    transform: "translate(-0.01 -0.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.24,1.28h29.34c8.16,0,14.49,2.29,18.7,6.51,3.58,3.58,5.5,8.62,5.5,14.67v.18c0,10.36-5.59,16.87-13.75,19.9l15.68,22.92h-16.5L244.46,44.93H233.36V65.47H219.24Zm28.42,31.17c6.88,0,10.82-3.67,10.82-9.08V23.2c0-6.05-4.22-9.17-11.09-9.17h-14V32.46Z",
    transform: "translate(-0.01 -0.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.69,33.56v-.18c0-18.25,14.4-33.19,34.2-33.19s34,14.76,34,33v.18c0,18.25-14.4,33.19-34.2,33.19S282.69,51.8,282.69,33.56Zm53.46,0v-.18c0-11-8.07-20.17-19.44-20.17s-19.25,9-19.25,20v.18c0,11,8.07,20.17,19.44,20.17S336.15,44.56,336.15,33.56Z",
    transform: "translate(-0.01 -0.18)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M366.18,1.28h7.24V39.61L410.29,1.28h9.35L392.13,29.34l28.7,36.13h-9.08L387.09,34.38,373.43,48.23V65.47h-7.24Z",
    transform: "translate(-0.01 -0.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M432.75,1.28H440V65.47h-7.24Z",
    transform: "translate(-0.01 -0.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M458.79,1.28h22.28c20.17,0,34.11,13.84,34.11,31.91v.18c0,18.06-13.94,32.09-34.11,32.09H458.79Zm22.28,57.49c16.23,0,26.59-11,26.59-25.21v-.18C507.66,19.16,497.3,8,481.07,8H466v50.8Z",
    transform: "translate(-0.01 -0.18)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistrokidLight);
export default __webpack_public_path__ + "static/media/distrokid-light.e381005ab698451af5d1d60fda00911b.svg";
export { ForwardRef as ReactComponent };